(function ($) {
  DJ.addBehavior('notificationsListing', '#notifications_listing', {
    attach: function () {
      $(document).ready(function() {
        // Send ajax request to make notifications read.
        $.ajax({
          url: Drupal.url('notifications/mark-as-read'),
          headers: { 'X-CSRF-Token': drupalSettings.notifications.token },
        });
      });
    }
  });
})(jQuery);
